import VimeoHeroContainer from './vimeo_hero_container';

const VimeoHero = VimeoHeroContainer;
export default VimeoHero;
